<template>
  <section class="create-spv tw-mt-10 tw-relative">
    <div class="create-spv__container">
      <div class="create-spv-heading__div tw-mb-11 tw-mt-12">
        <h1 class="create-spv__heading tw-font-bold tw-text-xl tw-mb-1">
          Create an SPV
        </h1>
        <p class="tw-text-sm tw-text-black-light">
          Please provide your name and location
        </p>
      </div>
      <form
        @submit.prevent="validateForm = true"
        class="create-spv__form tw-p-6 tw-pb-8"
      >
        <h2
          class="create-spv__heading tw-text-secondary tw-flex tw-items-center tw-mb-12 tw-font-bold"
        >
          <img src="@/assets/img/file.svg" class="tw-mr-2" alt="file icon" />
          SPV Document
        </h2>
        <div class="tw-w-80 tw-mx-auto md:tw-mx-0 md:tw-ml-8">
          <InputField
            class="tw-mb-4"
            label="Name of SPV"
            name="business_name"
            :currentValue="request.business_name"
            :validate="validateForm"
            @input-changed="storeValue"
            @is-valid="handleValidation"
          />
          <Dropdown
            label="Country of Jurisdiction"
            :options="countries"
            name="country"
            :currentValue="request.country"
            :validate="validateForm"
            @input-changed="storeValue"
            @is-valid="handleValidation"
          />
          <div class="tw-w-full tw-mt-8 create-spv__dragdrop">
            <div class="tw-w-56">
              <CustomButton
                title="Create"
                class="tw-text-sm"
                :disabled="!$route.params || !$route.params.id"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
  import CustomButton from "@/components/general/BtnComponent";
  import InputField from "@/components/general/InputField";
  import Dropdown from "@/components/general/Dropdown";
  import { mapActions, mapGetters } from "vuex";
  import countryCode from "@/utils/json/countryCode.json";
  export default {
    name: "CreateNewSpv",
    data() {
      return {
        countriesObject: countryCode.countries,
        request: {
          business_name: "",
          country: "",
        },
        countries: ["Nigeria", "USA"],
        validateForm: false,
        validationResult: [],
      };
    },
    components: {
      CustomButton,
      InputField,
      Dropdown,
    },
    created() {
      if (this.$route.query.spvId) {
        this.getSpvInfo();
      }
    },
    computed: {
      ...mapGetters("Spv", ["spvInfo"]),
    },
    methods: {
      ...mapActions("Spv", ["requestSpv", "fetchSpv"]),
      ...mapActions(["showToast"]),
      storeValue(val) {
        this.request[val.name] = val.value;
      },
      handleValidation(value) {
        this.validationResult.push(value);
      },
      async getSpvInfo() {
        const spvId = this.$route.query.spvId;
        try {
          await this.fetchSpv(spvId);
          this.request.business_name = this.spvInfo.business_name;
          const countryObj = this.countriesObject.filter(
            (country) => country.code === this.spvInfo.country
          );
          this.request.country = countryObj[0].name;
        } catch (error) {
          return error;
        }
      },
      async requestNewSpv() {
        if (this.request.country === "Nigeria") {
          this.request.country = "NG";
        }
        const object = { request: this.request, id: this.$route.params.id };
        try {
          const response = await this.requestSpv(object);
          const { message, data } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.$router.push({
            name: "AddSpvInfo",
            params: { country: this.request.country, spvId: data._id },
          });
        } catch (error) {
          return error;
        }
      },
    },
    watch: {
      validationResult: {
        deep: true,
        handler(val) {
          if (
            val.length >= Object.keys(this.request).length &&
            !val.includes(false)
          ) {
            this.requestNewSpv();
          }
        },
      },
      validateForm(val) {
        if (val) {
          this.validationResult = [];
          setTimeout(() => {
            this.validateForm = false;
          }, 1000);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .create-spv {
    border-radius: 4px;
    &__container {
      max-width: 818px;
      margin-left: auto;
      margin-right: auto;
    }
    &__form {
      background: #ffffff;
      border: 1px solid #f1f3f6;
      box-sizing: border-box;
      border-radius: 4px;
      margin-bottom: 100px;
    }
    &__dragdrop {
      margin-left: auto;
      margin-right: auto;
      max-width: 690px;
    }
  }

  .required {
    color: indianred;
  }
</style>
